import axios from 'axios';

//혼디도랑 관련 store
const hondiStore = {
    state: {
        menuInfo: [],
        adoptInfo: [],
        adoptInfoOrigin: [],
        hospitalInfo: [],
        isFavorite: false,
        searchText: '',
    },

    mutations: {
        setMenuInfo(state, data) {
            state.menuInfo = data;
        },

        setAdoptInfo(state, data) {
            state.adoptInfoOrigin = data;
        },

        refreshAdoptInfo(state, data) {
            state.adoptInfoOrigin = data;
        },

        setHospitalInfo(state, data) {
            state.hospitalInfo = data;
        },

    },

    actions: {

        // 메뉴 정보 조회
        async getMenuInfo(context) {
            await axios.get('/hondi/menu/list', {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async (res) => {
                await context.commit('setMenuInfo', res.data);
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '메뉴 정보 조회'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 메뉴 정보 입력
        async insertMenuInfo(context, data) {
            await axios.post(`/hondi/menu/insert`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getMenuInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '메뉴 정보 입력'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 메뉴 정보 수정
        async modifyMenuInfo(context, data) {
            await axios.post(`/hondi/menu/modify`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getMenuInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '메뉴 정보 수정'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 메뉴 정보 삭제
        async deleteMenuInfo(context, data) {
            await axios.post(`/hondi/menu/delete`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getMenuInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '메뉴 정보 삭제'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 입양 현황 정보 조회
        async getAdoptInfo(context) {
            await axios.get(`/hondi/adopt/list`, {
                headers: {
                            'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then((res) => {
                context.commit('setAdoptInfo', res.data);
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '입양 현황 정보 조회'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 입양 현황 정보 갱신
        async refreshAdoptInfo(context) {
            await axios.get(`/hondi/adopt/list`,{
                headers: {
                            'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then((res) => {
                context.commit('refreshAdoptInfo', res.data);
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '입양 현황 정보 갱신'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 입양 현황 정보 입력
        async insertAdoptInfo(context, data) {
            let formData = new FormData();
            let files = data.petImage;

            if(!files.length){
                formData.append('petImage', []);
            } else {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    formData.append('petImage', file, encodeURIComponent(file.name));
                }
            }

            formData.append('isFavorite', JSON.stringify(data.isFavorite));
            formData.append('petName', JSON.stringify(data.petName));
            formData.append('petGender', JSON.stringify(data.petGender));
            formData.append('petBirth', JSON.stringify(data.petBirth));
            formData.append('petAge', JSON.stringify(data.petAge));
            formData.append('petWeight', JSON.stringify(data.petWeight));
            formData.append('petKind', JSON.stringify(data.petKind));
            formData.append('petBreed', JSON.stringify(data.petBreed));
            formData.append('petRegNum', JSON.stringify(data.petRegNum));
            formData.append('petAdopt', JSON.stringify(data.petAdopt));
            formData.append('petAdoptDate', JSON.stringify(data.petAdoptDate));
            formData.append('petNeutral', JSON.stringify(data.petNeutral));
            formData.append('petTreat', JSON.stringify(data.petTreat));
            formData.append('petMedical', JSON.stringify(data.petMedical));
            formData.append('petHealth', JSON.stringify(data.petHealth));
            formData.append('petRescue', JSON.stringify(data.petRescue));
            formData.append('petMemo', JSON.stringify(data.petMemo));
            formData.append('petMemoDate', JSON.stringify(data.petMemoDate));
            formData.append('insertDate', data.insertDate);
            formData.append('insertId', data.insertId);

            await axios.post(`/hondi/adopt/insert`, formData, {
                headers: {
                            'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then((res) => {
                if(res.data.result == 'success'){
                    context.commit('setAlert', {  'alertStatus': 'notice'
                                                ,'alertTitle': '입양 현황 정보 입력'
                                                ,'alertContent': res.data.message});
                    context.dispatch('refreshAdoptInfo');
                }
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '입양 현황 정보 입력'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 입양 현황 정보 수정
        async modifyAdoptInfo(context, data) {
            let formData = new FormData();
            let files = data.petImage;
            let apiUrl = '';

            if(data.isImageChanged){
                //이미지 변경 포함
                apiUrl = '/hondi/adopt/modify/img'
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    formData.append('petImage', file, encodeURIComponent(file.name));
                }
            } else {
                apiUrl = '/hondi/adopt/modify/default'
            }
            
            formData.append('_id', data.id);
            formData.append('isFavorite', JSON.stringify(data.isFavorite));
            formData.append('petName', JSON.stringify(data.petName));
            formData.append('petGender', JSON.stringify(data.petGender));
            formData.append('petBirth', JSON.stringify(data.petBirth));
            formData.append('petAge', JSON.stringify(data.petAge));
            formData.append('petWeight', JSON.stringify(data.petWeight));
            formData.append('petKind', JSON.stringify(data.petKind));
            formData.append('petBreed', JSON.stringify(data.petBreed));
            formData.append('petRegNum', JSON.stringify(data.petRegNum));
            formData.append('petAdopt', JSON.stringify(data.petAdopt));
            formData.append('petAdoptDate', JSON.stringify(data.petAdoptDate));
            formData.append('petNeutral', JSON.stringify(data.petNeutral));
            formData.append('petTreat', JSON.stringify(data.petTreat));
            formData.append('petMedical', JSON.stringify(data.petMedical));
            formData.append('petHealth', JSON.stringify(data.petHealth));
            formData.append('petRescue', JSON.stringify(data.petRescue));
            formData.append('petMemo', JSON.stringify(data.petMemo));
            formData.append('petMemoDate', JSON.stringify(data.petMemoDate));
            formData.append('updateDate', data.updateDate);
            formData.append('updateId', data.updateId);

            //기 업로드 파일 삭제를 위해
            formData.append('isImageChanged', JSON.stringify(data.isImageChanged));
            formData.append('delImageInfo', JSON.stringify(data.delImageInfo));

            await axios.post(apiUrl, formData, {
                headers: {
                            'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then((res) => {
                if(res.data.result == 'success'){
                    context.commit('setAlert', {  'alertStatus': 'notice'
                                                ,'alertTitle': '입양 현황 정보 수정'
                                                ,'alertContent': res.data.message});
                    context.dispatch('refreshAdoptInfo');
                }
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '입양 현황 정보 수정'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 입양 현황 정보 삭제
        async deleteAdoptInfo(context, data) {
            await axios.post(`/hondi/adopt/delete`, {_id: data.id}, {
                headers: {
                            'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then((res) => {
                if(res.data.result == 'success'){
                    context.commit('setAlert', {  'alertStatus': 'notice'
                                                ,'alertTitle': '입양 현황 정보 삭제'
                                                ,'alertContent': res.data.message});
                    context.dispatch('refreshAdoptInfo');
                }
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '입양 현황 정보 삭제'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        //동물병원 정보 조회
        async getHospitalInfo(context) {
            await axios.get(`/hondi/hospital/list`, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async (res) => {
                await context.commit('setHospitalInfo', res.data);
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '동물병원 정보 조회'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 동물병원 정보 입력
        async insertHospitalInfo(context, data) {
            await axios.post(`/hondi/hospital/insert`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getHospitalInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '동물병원 정보 입력'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 동물병원 정보 수정
        async modifyHospitalInfo(context, data) {
            await axios.post(`/hondi/hospital/modify`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getHospitalInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '동물병원 정보 수정'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },

        // 동물병원 정보 삭제
        async deleteHospitalInfo(context, data) {
            await axios.post(`/hondi/hospital/delete`, data, {
                headers: {
                    'Authorization': context.rootGetters.getCryptNum
                }
            })
            .then(async () => {
                await context.dispatch('getHospitalInfo');
            })
            .catch((error) => {
                context.commit('setAlert', {  'alertStatus': 'error'
                                                ,'alertTitle': '동물병원 정보 삭제'
                                                ,'alertContent': `오류 발생|${error}`});
            })
        },
    },

    getters: {
        getPetAdoptInfo(state) {
            if(state.searchText != '') {
                let text = state.searchText;
                let temp = [];

                state.adoptInfoOrigin.forEach(a => {
                    if(JSON.stringify(a).indexOf(text) > -1){
                        temp.push(a);
                    }
                });

                state.adoptInfo = temp;
            } else {
                state.adoptInfo = state.adoptInfoOrigin;
            }

            if(state.isFavorite){
                state.adoptInfo = state.adoptInfo.filter((a) => a.isFavorite);
            }

            return state.adoptInfo;
        }
    }
    
}


export default hondiStore;